module.exports = __webpack_public_path__ + "static/media/arrow-down-copy.737bc57b.svg";